<template>

  <!-- ===== Top white section with logo and WhatsApp button ===== -->
  <div class="top-bar">
    <div class="hero-logo">
      <img src="@/assets/serious_logo.png" alt="Inter-Act Speaking Center Logo">
    </div>
    <a href="#" class="btn-whatsapp">WhatsApp</a>
  </div>

  <!-- Hero -->
  <section class="hero">
    <div class="hero-text">
      <h1>
        <span class="bold">Speak English with confidence</span><br>
        <span class="blue">at work and in daily life</span>
      </h1>
      <p>A method designed for speakers who truly want to advance</p>
    </div>
  </section>

  <!-- Images -->
  <div class="hero-images">
    <img src="@/assets/landing_page/student1.jpg" alt="Student 1">
    <img src="@/assets/landing_page/student2.jpg" alt="Student 2">
    <img src="@/assets/landing_page/student3.jpg" alt="Student 3">
  </div>

  <!-- Success Stories -->
  <section class="success">
    <h2><span style="font-weight:bold; color:#031567;">Our students</span> have worked at <span style="font-weight:bold; color:#031567;">leading companies</span> such as...</h2>
    <div class="success-logos">
      <img src="@/assets/landing_page/deloitte.png" alt="Deloitte">
      <img src="@/assets/landing_page/kpmg.png" alt="KPMG">
      <img src="@/assets/landing_page/pwc.png" alt="PwC">
      <img src="@/assets/landing_page/nestle.png" alt="Nestlé">
      <img src="@/assets/landing_page/kelloggs.png" alt="Kellogg's">
      <img src="@/assets/landing_page/mabe.png" alt="Mabe">
      <img src="@/assets/landing_page/larousse.png" alt="Larousse">
      <img src="@/assets/landing_page/lear.png" alt="Lear">
    </div>
    <div class="testimonial">
      <img src="@/assets/landing_page/testimony1.png" alt="Inter-Act Logo">
      <div class="testimonial-text">
        <p>Before, it was very hard for me to participate in meetings in English, but after 3 months at Inter-Act Speaking Center I was able to communicate more confidently and even lead presentations. I’m proud of what I’ve achieved and I keep improving.</p>
        <strong>Ana Lopez, Project Manager</strong>
      </div>
    </div>
  </section>

  <!-- Problems -->
  <section class="problems">
    <h2><span class="blue">Have you faced</span> <span class="red">any of these problems?</span></h2>
    <div class="problem-cards">
      <div class="problem-card"><p>I don’t understand in meetings</p></div>
      <div class="problem-card"><p>I’m shy to speak</p></div>
      <div class="problem-card"><p>I feel like I don’t improve with apps</p></div>
      <div class="problem-card"><p>I want to travel and understand what people say</p></div>
      <div class="problem-card"><p>I get stuck when speaking and lack confidence</p></div>
    </div>
  </section>

  <!-- Solution -->
  <section class="solution">
    <img src="@/assets/landing_page/classroom.jpg" alt="Online class">
    <div class="solution-text">
      <h2>We created <span>Inter-Act Speaking Center</span></h2>
      <ul>
        <li><b>Foreign teachers</b> who correct you in real time.</li>
        <li><b>100% online classes</b>, so you can learn from anywhere.</li>
        <li><b>Focus on conversation</b>, not just grammar.</li>
        <li><b>Job interview simulations</b> to prepare with confidence.</li>
        <li><b>Practical method</b> with real-life and work situations.</li>
      </ul>
    </div>
  </section>

  <!-- Packages -->
  <section class="packages">
    <h2>With <span style="color:#031567; font-weight:bold;">Inter-Act Speaking Center</span> you don’t just study English, <span style="color:#00B0F0;">you live it in every class</span></h2>
    <p style="font-size:24px; margin-bottom:40px;">Choose the option that best fits you</p>
    <div class="package-options">

      <div class="package">
        <img src="@/assets/landing_page/student3.jpg" alt="Individual Classes">
        <h3 class="blue">Individual</h3>
        <ul>
          <li>100% personalized attention</li>
          <li>Learn at your own pace</li>
          <li>Ideal for fast preparation</li>
          <li>From $20 USD per class</li>
        </ul>
        <a href="https://wa.me/525515902969?text=Hello,%20I'm%20interested%20in%20individual%20classes.%20I%20would%20like%20to%20book%20my%20free%20class,%20please" class="btn-package">Book Free Class</a>
      </div>

      <div class="package">
        <img src="@/assets/landing_page/group.jpg" alt="Small Group">
        <h3 class="blue">Small Group</h3>
        <ul>
          <li>Maximum 2–5 students per class</li>
          <li>Real interaction with classmates</li>
          <li>More dynamic and affordable</li>
          <li>From $10 USD per class per person</li>
        </ul>
        <a href="https://wa.me/525515902969?text=Hello,%20I'm%20interested%20in%20small%20group%20classes.%20I%20would%20like%20to%20book%20my%20free%20class,%20please" class="btn-package">Book Free Class</a>
      </div>

      <div class="package">
        <img src="@/assets/landing_page/special.jpg" alt="Special Programs">
        <h3 class="blue">Special Programs</h3>
        <ul>
          <li>Intensive job interview prep</li>
          <li>TOEFL / IELTS preparation</li>
          <li>Weekly goal-based plans</li>
          <li>From $20 USD per class per person</li>
        </ul>
        <a href="https://wa.me/525515902969?text=Hello,%20I'm%20interested%20in%20the%20special%20programs.%20I%20would%20like%20to%20book%20my%20free%20class,%20please" class="btn-package">Book Free Class</a>
      </div>

      <div class="package">
        <img src="@/assets/landing_page/business.jpg" alt="Business Package">
        <h3 class="red">Business Package</h3>
        <ul>
          <li>Training for entire teams</li>
          <li>Specialized teachers</li>
          <li><b>Sessions adapted to your industry</b></li>
          <li>Boost competitiveness and confidence</li>
          <li>Maximum 2–5 students per class</li>
          <li>From $28 USD per class</li>
        </ul>
        <a href="https://wa.me/525515902969?text=Hello,%20I'm%20interested%20in%20the%20business%20classes.%20I%20would%20like%20to%20book%20my%20free%20class,%20please" class="btn-package">Contact Us</a>
      </div>

    </div>
  </section>

  <!-- ===== FAQ ===== -->
  <section class="faq" style="background-color:#FFFFFF; padding:60px 40px;">
    <h2 style="font-size:24px; color:#000000; margin-bottom:30px;">We answer your most common questions</h2>

    <div class="faq-item" style="margin-bottom:20px;">
      <h3 style="font-size:14px; color:#031567;">How much does it cost?</h3>
      <p style="font-size:16px; margin:0; color:#031567;">• It depends on the plan you choose. We have group classes from $10 USD and individual classes from $20 USD. Plus, the <b>first class is free</b>.</p>
    </div>

    <div class="faq-item" style="margin-bottom:20px;">
      <h3 style="font-size:14px; color:#031567;">What level do I need to start?</h3>
      <p style="font-size:16px; margin:0; color:#031567;">• None. Our program adapts to beginners, intermediate, or advanced students.</p>
    </div>

    <div class="faq-item">
      <h3 style="font-size:14px; color:#031567;">Is it 100% online?</h3>
      <p style="font-size:16px; margin:0; color:#031567;">• Yes, you can join from anywhere. You only need internet and a device.</p>
    </div>
  </section>

  <!-- ===== Footer ===== -->
  <footer class="footer" style="background-color:#F2F2F2; text-align:center; padding:40px 20px;">
    <h2 style="font-size:32px; color:#031567; margin-bottom:20px;">
      <b>Speak English with confidence</b><br>
      <span style="font-weight:normal;">at work and in daily life</span>
    </h2>

    <div class="footer-logo" style="margin:20px 0;">
      <img src="@/assets/serious_logo.png" alt="Inter-Act Logo" style="width:80px;">
    </div>

    <div style="display:flex; justify-content:space-between; align-items:center; max-width:900px; margin:0 auto;">
      <a href="https://wa.me/525515902969?text=Hello,%20I'm%20interested%20in%20teaching%20with%20your%20school,%20please" style="background-color:#031567; color:#FFFFFF; padding:10px 25px; border-radius:8px; text-decoration:none; font-size:16px;">Apply to be a teacher</a>
      <a href="https://wa.me/525515902969?text=Hello,%20I'm%20interested%20in%20individual%20classes.%20I%20would%20like%20to%20book%20my%20free%20class,%20please" style="background-color:#4EA72E; color:#FFFFFF; padding:10px 25px; border-radius:8px; text-decoration:none; font-size:18px; font-weight:bold;">Contact Us</a>
    </div>
  </footer>

</template>




<script setup>



</script>



 <style scoped>

    body {

      margin: 0;

      font-family: "Microsoft Tai Le", sans-serif;

      color: #000000;

    }

 

    /* ===== Sección superior (blanca) ===== */

    .top-bar {

      background-color: #FFFFFF;

      display: flex;

      justify-content: space-between;

      align-items: center;

      padding: 20px 40px;

    }

 

    .top-bar .hero-logo img {

      width: 120px;

    }

 

    .top-bar .btn-whatsapp {

      background-color: #4EA72E;

      color: #FFFFFF;

      padding: 10px 25px;

      border-radius: 8px;

      text-decoration: none;

      font-size: 18px;

      font-weight: bold;

    }

 

    /* ===== Sección Hero (gris) ===== */

    .hero {

      text-align: center;

      background-color: #F2F2F2;

      padding: 40px 20px;

    }

 

    .hero-text h1 {

      font-size: 32px;

      line-height: 1.3;

      margin-bottom: 10px;

    }

 

    .hero-text h1 .bold {

      font-weight: bold;

      color: #031567;

    }

 

    .hero-text h1 .blue {

      color: #031567;

      font-weight: normal;

    }

 

    .hero-text p {

      font-size: 20px;

      margin-bottom: 30px;

      color: #000000;

    }

 

    /* ===== Sección de imágenes (blanca) ===== */

    .hero-images {

      background-color: #FFFFFF;

      padding: 40px 20px;

      display: flex;

      justify-content: center;

      gap: 20px;

    }

 

    .hero-images img {

      width: 180px;

      height: auto;

      border-radius: 20px;

      object-fit: cover;

    }

 

    /* ===== Sección Casos de Éxito (azul claro) ===== */

    .success {

      background-color: #C1E5F5;

      text-align: center;

      padding: 50px 20px;

    }

 

    .success h2 {

      font-size: 28px;

      color: #031567;

      margin-bottom: 30px;

    }

 

    .success-logos {

      display: flex;

      flex-wrap: wrap;

      justify-content: center;

      align-items: center;

      gap: 40px;

      margin-bottom: 40px;

    }

 

    .success-logos img {

      max-height: 70px;

      object-fit: contain;

    }

 

    .testimonial {

      background-color: #FFFFFF;

      padding: 40px;

      display: flex;

      align-items: center;

      gap: 30px;

      justify-content: center;

    }

 

    .testimonial img {

      width: 100px;

      height: auto;

    }

 

    .testimonial-text {

      max-width: 700px;

      font-size: 18px;

      line-height: 1.5;

      color: #031567;

      text-align: left;

    }

 

    .testimonial-text strong {

      display: block;

      margin-top: 10px;

      font-size: 16px;

      font-weight: bold;

    }

 

    /* ===== Sección Problemas ===== */

    .problems {

      background-color: #F2CFEE;

      text-align: center;

      padding: 50px 20px;

    }

 

    .problems h2 {

      font-size: 20px;

      margin-bottom: 40px;

    }

 

    .problems h2 .blue {

      color: #031567;

      font-weight: bold;

    }

 

    .problems h2 .red {

      color: #FF0000;

      font-weight: bold;

    }

 

    .problem-cards {

      display: flex;

      flex-wrap: wrap;

      justify-content: center;

      gap: 20px;

    }

 

    .problem-card {

      background-color: #FFFFFF;

      width: 200px;

      padding: 20px;

      border-radius: 20px;

      box-shadow: 0 2px 5px rgba(0,0,0,0.1);

      font-size: 18px;

      color: #031567;

    }

 

    .problem-card p {

      margin: 0;

      font-size: 18px;

    }

 

    /* ===== Sección Solución ===== */

    .solution {

      background-color: #FFFFFF;

      padding: 60px 20px;

      display: flex;

      align-items: center;

      justify-content: center;

      gap: 40px;

    }

 

    .solution img {

      width: 200px;

      height: auto;

      border-radius: 12px;

    }

 

    .solution-text h2 {

      font-size: 36px;

      color: #00B0F0;

      margin-bottom: 20px;

    }

 

    .solution-text h2 span {

      color: #031567;

      font-weight: bold;

    }

 

    .solution-text ul {

      list-style: none;

      padding: 0;

    }

 

    .solution-text ul li {

      font-size: 16px;

      margin-bottom: 10px;

    }

 

    .solution-text ul li::before {

      content: '✔';

      color: #4EA72E;

      margin-right: 10px;

      font-weight: bold;

    }

 

    /* ===== Sección Paquetes ===== */

    .packages {

      background-color: #F2F2F2;

      text-align: center;

      padding: 60px 20px;

    }

 

    .packages h2 {

      font-size: 32px;

      margin-bottom: 40px;

      color: #031567;

    }

 

    .package-options {

      display: flex;

      flex-wrap: wrap;

      justify-content: center;

      gap: 30px;

    }

 

    .package {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;


      background-color: #FFFFFF;

      border-radius: 20px;

      padding: 20px;

      width: 260px;

      box-shadow: 0 2px 6px rgba(0,0,0,0.1);

    }

 

    .package img {

      width: 100%;

      border-radius: 12px;

      margin-bottom: 15px;

    }

 

    .package h3 {

      font-size: 20px;

      margin-bottom: 10px;

    }

 

    .package h3.blue { color: #00B0F0; }

    .package h3.red { color: #FF0000; }

 

    .package ul {

      list-style: none;

      padding: 0;

      margin: 0 0 20px 0;

      text-align: left;

    }

 

    .package ul li {

      margin-bottom: 8px;

      font-size: 14px;

    }

 

    .package .btn-package {

      display: inline-block;

      background-color: #4EA72E;

      color: #FFFFFF;

      padding: 10px 20px;

      border-radius: 8px;

      text-decoration: none;

      font-weight: bold;

    }

 

    /* ===== Sección FAQ ===== */

    .faq {

      background-color: #FFFFFF;

      padding: 60px 40px;

    }

 

    .faq h2 {

      font-size: 24px;

      margin-bottom: 30px;

      color: #000000;

    }

 

    .faq-item {

      margin-bottom: 20px;

    }

 

    .faq-item h3 {

      font-size: 14px;

      color: #031567;

      margin-bottom: 5px;

    }

 

    .faq-item p {

      font-size: 16px;

      margin: 0;

    }

 

    /* ===== Footer ===== */

    .footer {

      background-color: #F2F2F2;

      text-align: center;

      padding: 40px 20px;

    }

 

    .footer h2 {

      font-size: 32px;

      margin-bottom: 20px;

      color: #031567;

    }

 

    .footer-logo img {

      width: 80px;

      margin: 20px 0;

    }

 

    .footer .btn-contacto {

      display: inline-block;

      background-color: #4EA72E;

      color: #FFFFFF;

      padding: 10px 25px;

      border-radius: 8px;

      text-decoration: none;

      font-size: 18px;

      font-weight: bold;

      margin-top: 20px;

    }

 

    .footer .btn-profesor {

      display: inline-block;

      background-color: #031567;

      color: #FFFFFF;

      padding: 10px 25px;

      border-radius: 8px;

      text-decoration: none;

      font-size: 16px;

      margin-top: 20px;

    }

  </style>